export default "__VITE_ASSET__DeSG1IbH__"